import { FC } from 'react';

import { useAuthentication, UserGroups } from '@ravago/shared/authentication';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';


import { Country } from '../../../services/contentful/locale.service';
import { DataTestSelector } from '../../../utils/format.utils';
import { CountryDropdown } from '../country-dropdown/country-dropdown';

interface Props {
  countries: Array<Country>;
  selectedCountryCode?: string;
  onCountrySelect?: (countryCode: string) => void;
}

const CountrySwitch: FC<Props> = ({ countries, selectedCountryCode, onCountrySelect }: Props) => {
  const translate = useTranslations();

  const { user } = useAuthentication();
  const canChangeCountry =
    !user ||
    [UserGroups.digitalPlatformGuest, UserGroups.digitalPlatformPendingVerification].some((group) => user.groups.includes(group));

  const handleCountrySelect = (selectedCountryCode: string) => {
    onCountrySelect?.(selectedCountryCode);
  };

  const countryCodes = countries.map((country) => country.shortName);

  return (
    <Box direction="column" gap="sm">
      <Typography variant="body-highlight" color="strong">
        {translate('page-consumer.header.country-selector.header')}
      </Typography>
      <Typography variant="body" color="subtle">
        {translate('page-consumer.header.country-selector.description')}
      </Typography>

      <CountryDropdown
        id="country-selector"
        label={translate('page-consumer.header.country-selector.label')}
        attributes={{ ...DataTestSelector('country-switch-dropdown') }}
        countries={countryCodes}
        selectedCountryCode={selectedCountryCode}
        onChange={handleCountrySelect}
        disabled={!canChangeCountry}
      />
    </Box>
  );
};

export default CountrySwitch;
